// @format
import { omit, pick } from 'ramda';
import { mapProps, compose } from 'recompose';

export const omitProps = compose(mapProps, omit);
export const pickProps = compose(mapProps, pick);



// WEBPACK FOOTER //
// ./src/modules/hocs/utils.js